import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AddressGrid from '../components/AddressGrid';
import AddressModal from '../components/AddressModal';
import apiClient from '../api';
import './pages.css';

const MainPage = () => {
  const navigate = useNavigate();
  const [addresses, setAddresses] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [loading, setLoading] = useState(true);

  // Загрузка адресов при монтировании компонента
  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/addresses');
      // Преобразование данных из формата backend в формат frontend
      const transformedAddresses = response.data.map(addr => ({
        id: addr.id,
        city: addr.city,
        street: addr.street,
        building: addr.house_number,
        apartment: addr.apartment_number || ''
      }));
      setAddresses(transformedAddresses);
    } catch (error) {
      console.error('Ошибка загрузки адресов:', error);
      alert('Не удалось загрузить адреса');
    } finally {
      setLoading(false);
    }
  };

  const handleAddClick = () => {
    setEditingAddress(null);
    setIsModalOpen(true);
  };

  const handleEdit = (address) => {
    setEditingAddress(address);
    setIsModalOpen(true);
  };

  const handleDelete = async (address) => {
    if (!window.confirm(`Удалить адрес: ${address.city}, ${address.street}?`)) {
      return;
    }

    try {
      await apiClient.delete(`/addresses/${address.id}`);
      setAddresses(prev => prev.filter(a => a.id !== address.id));
    } catch (error) {
      console.error('Ошибка удаления адреса:', error);
      alert('Не удалось удалить адрес');
    }
  };

  const handleSave = async (formData) => {
    try {
      // Преобразование данных из формата frontend в формат backend
      const backendData = {
        city: formData.city,
        street: formData.street,
        house_number: formData.building,
        apartment_number: formData.apartment || null
      };

      if (editingAddress) {
        // Обновление существующего адреса
        const response = await apiClient.put(`/addresses/${editingAddress.id}`, backendData);
        const updatedAddress = {
          id: response.data.address.id,
          city: response.data.address.city,
          street: response.data.address.street,
          building: response.data.address.house_number,
          apartment: response.data.address.apartment_number || ''
        };
        setAddresses(prev => prev.map(a => 
          a.id === editingAddress.id ? updatedAddress : a
        ));
      } else {
        // Создание нового адреса
        const response = await apiClient.post('/addresses', backendData);
        const newAddress = {
          id: response.data.address.id,
          city: response.data.address.city,
          street: response.data.address.street,
          building: response.data.address.house_number,
          apartment: response.data.address.apartment_number || ''
        };
        setAddresses(prev => [...prev, newAddress]);
      }
      
      setIsModalOpen(false);
      setEditingAddress(null);
    } catch (error) {
      console.error('Ошибка сохранения адреса:', error);
      alert('Не удалось сохранить адрес');
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingAddress(null);
  };

  const handleAddressClick = (address) => {
    navigate(`/addresses/${address.id}/services`);
  };

  if (loading) {
    return (
      <div className="page">
        <h1 className="page-title">Мои адреса</h1>
        <div className="loading">Загрузка...</div>
      </div>
    );
  }

  return (
    <div className="page">
      <h1 className="page-title">Мои адреса</h1>
      <AddressGrid
        addresses={addresses}
        onAddClick={handleAddClick}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onAddressClick={handleAddressClick}
      />
      <AddressModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSave}
        address={editingAddress}
      />
    </div>
  );
};

export default MainPage;
